/**
 * Logger Utility - Production'da console log'ları kontrol eder
 * 
 * Kullanım:
 * - Development: Tüm log'lar gösterilir
 * - Production: Sadece error ve warn gösterilir (opsiyonel)
 */

// Environment kontrol
const isDevelopment = process.env.NODE_ENV === 'development';
const isProduction = process.env.NODE_ENV === 'production';

// Production'da log gösterilsin mi?
const SHOW_LOGS_IN_PRODUCTION = false;

export const logger = {
  log: (...args: any[]) => {
    if (isDevelopment || SHOW_LOGS_IN_PRODUCTION) {
      console.log(...args);
    }
  },

  info: (...args: any[]) => {
    if (isDevelopment || SHOW_LOGS_IN_PRODUCTION) {
      console.info(...args);
    }
  },

  warn: (...args: any[]) => {
    if (isDevelopment || isProduction) {
      console.warn(...args);
    }
  },

  error: (...args: any[]) => {
    if (isDevelopment || isProduction) {
      console.error(...args);
    }
  },

  debug: (...args: any[]) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },

  table: (data: any) => {
    if (isDevelopment) {
      console.table(data);
    }
  },

  group: (label: string) => {
    if (isDevelopment) {
      console.group(label);
    }
  },

  groupEnd: () => {
    if (isDevelopment) {
      console.groupEnd();
    }
  },

  time: (label: string) => {
    if (isDevelopment) {
      console.time(label);
    }
  },

  timeEnd: (label: string) => {
    if (isDevelopment) {
      console.timeEnd(label);
    }
  },

  clear: () => {
    if (isDevelopment) {
      console.clear();
    }
  }
};

// Development ortamında helper mesajları
if (isDevelopment) {
  logger.info('🚀 Logger aktif - Development Mode');
  logger.info('📝 Tüm log\'lar gösteriliyor');
} else {
  logger.info('🚀 Logger aktif - Production Mode');
  logger.info('⚠️ Sadece error ve warn log\'ları gösteriliyor');
}

export default logger;


